import { useMutation, UseQueryResult } from '@tanstack/react-query';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';

import { deleteKycFileViaMip } from '@dealstack/frontend/shared/dataExchange/services/shareholder/investment.service';

export const useDeleteKycFile = (getKYCDataRequest: UseQueryResult) => {
	const mutation = useMutation<void, Error, { fileId: string; userId: string }>({
		mutationFn: (variables: Parameters<typeof deleteKycFileViaMip>[0]) =>
			deleteKycFileViaMip(variables),
	});

	const deleteKycFile = ({ fileId, userId }: { fileId: string; userId: string }) => {
		mutation.mutate(
			{ fileId, userId },
			{
				onSuccess: () => {
					void getKYCDataRequest.refetch();

					showToastV2({
						title: 'Deleted',
						state: 'success',
					});
				},
			}
		);
	};

	return {
		deleteKycFile,
		mutation,
	};
};
